import VideoGuestBookGreetingModal, {
  VIDEO_GUEST_BOOK_GREETING_MODAL,
} from './VideoGuestBookGreetingModal';

export default VideoGuestBookGreetingModal;
export { VIDEO_GUEST_BOOK_GREETING_MODAL };
